export default {
  wrapper: {
    backgroundColor: '#fff1f1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh'
  },
  title: {
    color: '#fb3958',
    fontFamily: 'Montserrat',
    fontSize: 80,
    fontWeight: 600,
    marginBottom: 15
  },
  errorIcon: {
    width: 300
  },
  container: {
    backgroundColor: '#fff',
    border: '1px solid #d8d8d8',
    borderRadius: '4px',
    fontSize: 18,
    padding: '20px',
    position: 'relative',
    textAlign: 'center',
    width: '75%',
    maxWidth: 700,
    '& strong': {
      color: '#fb3958',
      display: 'block',
      fontSize: 20,
      fontWeight: 600,
      marginBottom: 15
    },
    '& a': {
      display: 'block',
      fontSize: 18
    }
  }
};
